/**
 * Props:
 * targets: query selector for the toggled targets | string,
 * isVisible: is the targets currently visible | boolean | default to 'false',
 */

export default {
  name: 'toggle-visibility',

  ui: {
    showIndicator: '[js-toggle-visibility-show]',
    hideIndicator: '[js-toggle-visibility-hide]',
  },

  events: [
    {
      on: 'click',
      handle () {
        const targets = document.querySelectorAll(this.props.targets)

        targets.forEach(target => {
          target.classList.toggle('hidden')
          target.classList.toggle('flex')
        })

        // this.ui.showIndicator.classList.toggle('hidden')
        // this.ui.hideIndicator.classList.toggle('hidden')
      },
    },
  ],

  componentDidMount () {
    this.isVisible = this.props.isVisible || false
  },
}
